module.exports = __webpack_public_path__ + "static/media/ci-3.1e6f1951.jpg";